module.exports = __webpack_public_path__ + "static/media/logo_vibbra_color.8a502401.svg";